/* DIRT2STREET compatibility layer retained across Pillar updates. */
(() => {
  const getMap = () => { try { return JSON.parse(document.getElementById('variant-leadtime-map')?.textContent || '{}'); } catch (_) { return {}; } };
  const update = (variant) => {
    if (!variant) return;
    const item = getMap()[variant.id];
    const leadtime = document.getElementById('leadtime-message');
    if (leadtime) leadtime.textContent = item?.message || '';
    if (item?.message && item.message.startsWith('Out of Stock')) {
      document.querySelectorAll('#ProductSubmitButton .btn__text, sticky-atc-bar .btn__text, sticky-atc-bar-minimalist .btn__text').forEach((el) => { el.textContent = item.message === 'Sold Out' ? 'Sold Out' : 'Out of Stock'; });
    }
  };
  let promoCheckRunning = false;
  const removeOrphanPromos = async () => {
    if (promoCheckRunning) return;
    promoCheckRunning = true;
    try {
      const cart = await fetch('/cart.js').then((response) => response.json());
      const groups = {};
      cart.items.forEach((line, index) => {
        const id = line.properties?._bundle_id;
        if (!id) return;
        (groups[id] ||= { kits: 0, promos: [], required: 0 });
        if (line.properties._bundle_role === 'promo') groups[id].promos.push(index + 1);
        else groups[id].kits += 1;
        groups[id].required = Math.max(groups[id].required, Number(line.properties._bundle_required_kit_count || 0));
      });
      const updates = {};
      Object.values(groups).forEach((group) => { if (group.required && group.kits < group.required) group.promos.forEach((line) => { updates[line] = 0; }); });
      if (Object.keys(updates).length) await fetch('/cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates }) });
    } catch (_) {} finally { promoCheckRunning = false; }
  };
  document.addEventListener('DOMContentLoaded', () => {
    const raw = document.querySelector('[data-variants-cache]')?.textContent;
    if (raw) { try { const id = document.querySelector('[name="id"].product-variant-id')?.value; update(JSON.parse(raw).find((v) => String(v.id) === String(id))); } catch (_) {} }
    const observer = new MutationObserver(() => {
      const chat = document.querySelector('inbox-online-store-chat#ShopifyChat');
      const drawer = document.querySelector('cart-drawer#CartDrawer');
      if (chat && drawer) chat.style.right = drawer.hasAttribute('open') && drawer.hasAttribute('active') ? '500px' : '16px';
    });
    observer.observe(document.body, { attributes: true, subtree: true, attributeFilter: ['open', 'active'] });
    const syncHeaderHeight = () => {
      const headerSection = document.querySelector('.header-section');
      if (headerSection) document.documentElement.style.setProperty('--d2s-header-height', Math.ceil(headerSection.getBoundingClientRect().height) + 'px');
    };
    syncHeaderHeight();
    const headerSection = document.querySelector('.header-section');
    if (headerSection && window.ResizeObserver) new ResizeObserver(syncHeaderHeight).observe(headerSection);
    window.addEventListener('resize', syncHeaderHeight);
    removeOrphanPromos();
  });
  document.addEventListener('variant:changed', (event) => update(event.detail?.variant));
  document.addEventListener('variant:change', (event) => update(event.detail?.variant));
  if (window.FoxTheme?.pubsub?.subscribe) FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, ({ data }) => update(data?.variant));
  if (window.FoxTheme?.pubsub?.subscribe) FoxTheme.pubsub.subscribe(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, () => setTimeout(removeOrphanPromos, 250));
})();
